export const getHTMLElementName = (name: string, nameSuffix?: string) =>
  nameSuffix ? `${name}${nameSuffix}` : name;
